// @core/api/endpoints/calendar/import_calendar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ImportCalendarRequest,
  ImportCalendarResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Import calendar
 * Imports events from iCalendar (.ics) format into the specified calendar. Supports single events and recurring event series.
 */
export async function ImportCalendar(
  calendar_id: string,
  data: ImportCalendarRequest,
  options?: RequestOptions
): Promise<ImportCalendarResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id/import`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  const requestOptions = options;
  return client.post<ImportCalendarResponse>(requestPath, data, requestOptions);
}
